import axios from "axios";

const API_BASE_URL = "https://api.drymatec.de/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Login API Call
export const login = async (username: string, password: string) => {
  const response = await apiClient.post("/auth/login", { username, password });
  return response.data;
};

// Sign-Up API Call
export const signup = async (username: string, password: string, email: string) => {
  const response = await apiClient.post("/auth/signup", {
    username,
    password,
    email
  });
  return response.data;
};

//  getAllUsers API Call
export const getAllUsers = async () => {
  const response = await apiClient.get("/user");
  return response.data;
};

//  getAllDevices API Call
export const getAllDevices = async () => {
  const response = await apiClient.get("/devices");
  return response.data;
};
